import React, { ComponentType } from 'react';
import { getIsAuthenticated } from '../utils/getIsAuthenticated';
import { withInvariant } from '../utils/withInvariant';
import { Redirect } from './Redirect';

export function withAuthProtection<TProps extends {}>(
    BaseComponent: ComponentType<TProps>,
): ComponentType<TProps> {
    return withInvariant(
        (props: TProps) => {
            if (getIsAuthenticated()) {
                // @ts-ignore
                return <BaseComponent {...props} />;
            }

            return (
                <Redirect
                    url={`${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`}
                />
            );
        },
        () => null,
    );
}
